var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSharedNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2443_13428)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2246 17.5068C24.0513 18.7468 25.3313 20.4268 25.3313 22.6668V26.6668H29.3313C30.0646 26.6668 30.6646 26.0668 30.6646 25.3335V22.6668C30.6646 19.7602 25.9046 18.0402 22.2246 17.5068Z",
    fill: "#6F6F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 16.0002C14.9449 16.0002 17.3327 13.6123 17.3327 10.6668C17.3327 7.72131 14.9449 5.3335 11.9993 5.3335C9.05383 5.3335 6.66602 7.72131 6.66602 10.6668C6.66602 13.6123 9.05383 16.0002 11.9993 16.0002Z",
    fill: "#6F6F67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9979 16.0002C22.9446 16.0002 25.3313 13.6135 25.3313 10.6668C25.3313 7.72016 22.9446 5.3335 19.9979 5.3335C19.3713 5.3335 18.7846 5.46683 18.2246 5.6535C19.3313 7.02683 19.9979 8.7735 19.9979 10.6668C19.9979 12.5602 19.3313 14.3068 18.2246 15.6802C18.7846 15.8668 19.3713 16.0002 19.9979 16.0002Z",
    fill: "#6F6F67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9987 17.3335C8.4387 17.3335 1.33203 19.1202 1.33203 22.6668V25.3335C1.33203 26.0668 1.93203 26.6668 2.66536 26.6668H21.332C22.0654 26.6668 22.6654 26.0668 22.6654 25.3335V22.6668C22.6654 19.1202 15.5587 17.3335 11.9987 17.3335Z",
    fill: "#6F6F67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2443_13428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedNotes);
export default __webpack_public_path__ + "static/media/shared-notes.7de593586de6088394755a59dae3b1ce.svg";
export { ForwardRef as ReactComponent };